import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem, ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { ApiService } from 'src/app/_services/api.service';

@Component({
  selector: 'app-setup-hp',
  templateUrl: './setup-hp.component.html',
  styleUrls: ['./setup-hp.component.css'],
  providers: [ConfirmationService, MessageService]
})
export class SetupHpComponent implements OnInit {
  
  hplist:any[]=[];

  constructor(
    private router: Router,
    private apiService: ApiService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
  ) { }

  ngOnInit(): void {
    this.gellhp();
  }
  gellhp(){
    this.apiService.get('hp/listall',{}).subscribe(data => {
      this.hplist=data.Result;
      });
  }
  edit(hp){   
    this.router.navigateByUrl('/dashboard/setup-hp/setup-hp-edit/update/'+hp.id);
  }
  delete(hp){
    this.confirmationService.confirm({
      message: 'Si conferma la cancellazione della homepage?',
      accept: () => {
        this.apiService.get('hp/delete_hp',{'id':hp.id}).subscribe(data => {
          this.gellhp();
        });
        
      }
    });
  }
  
}
